import React from 'react';

const SupportPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 font-sans">
      <div className="max-w-2xl mx-auto">

        {/* Header */}
        <div className="text-center mb-10">
          <div className="flex justify-center mb-4">
            <div className="w-16 h-16 bg-blue-600 rounded-2xl flex items-center justify-center shadow-md">
              <span className="text-white font-bold text-2xl">S</span>
            </div>
          </div>
          <h1 className="text-3xl font-bold text-gray-900">SparkCRM Support</h1>
          <p className="mt-2 text-gray-500 text-sm">We're here to help. Reach out through any of the channels below.</p>
        </div>

        {/* Contact Cards */}
        <div className="space-y-4">

          {/* Email */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-5 flex items-start gap-4">
            <div className="p-3 bg-blue-50 rounded-xl text-blue-600 flex-shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
            <div>
              <p className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-0.5">Email Support</p>
              <a href="mailto:support@sparkcrm.in" className="text-blue-600 font-semibold text-base hover:underline">
                support@sparkcrm.in
              </a>
              <p className="text-xs text-gray-400 mt-1">We respond within 24 business hours</p>
            </div>
          </div>

          {/* Phone */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-5 flex items-start gap-4">
            <div className="p-3 bg-green-50 rounded-xl text-green-600 flex-shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
            </div>
            <div>
              <p className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-0.5">Phone Support</p>
              <a href="tel:+911234567890" className="text-green-600 font-semibold text-base hover:underline">
                +91 12345 67890
              </a>
              <p className="text-xs text-gray-400 mt-1">Mon – Sat, 10:00 AM – 6:00 PM IST</p>
            </div>
          </div>

          {/* WhatsApp */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-5 flex items-start gap-4">
            <div className="p-3 bg-emerald-50 rounded-xl text-emerald-600 flex-shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
              </svg>
            </div>
            <div>
              <p className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-0.5">WhatsApp</p>
              <a
                href="https://wa.me/911234567890"
                target="_blank"
                rel="noopener noreferrer"
                className="text-emerald-600 font-semibold text-base hover:underline"
              >
                Chat with us
              </a>
              <p className="text-xs text-gray-400 mt-1">Quick responses during business hours</p>
            </div>
          </div>

          {/* Website */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-5 flex items-start gap-4">
            <div className="p-3 bg-purple-50 rounded-xl text-purple-600 flex-shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
              </svg>
            </div>
            <div>
              <p className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-0.5">Website</p>
              <a
                href="https://sparkcrm.in"
                target="_blank"
                rel="noopener noreferrer"
                className="text-purple-600 font-semibold text-base hover:underline"
              >
                sparkcrm.in
              </a>
              <p className="text-xs text-gray-400 mt-1">Visit our website for more information</p>
            </div>
          </div>

        </div>

        {/* App Info — required for App Store review */}
        <div className="mt-8 bg-white rounded-xl border border-gray-100 shadow-sm p-5">
          <h2 className="text-sm font-semibold text-gray-700 mb-3">About SparkCRM</h2>
          <p className="text-sm text-gray-500 leading-relaxed">
            SparkCRM is a comprehensive business management platform that helps you manage employees,
            leads, tasks, attendance, payroll, and more — all in one place.
          </p>
          <div className="mt-4 grid grid-cols-2 gap-3 text-xs text-gray-400">
            <div>
              <span className="font-semibold text-gray-500">App Version</span>
              <p>1.0.0</p>
            </div>
            <div>
              <span className="font-semibold text-gray-500">Platform</span>
              <p>iOS / Android / Web</p>
            </div>
            <div>
              <span className="font-semibold text-gray-500">Developer</span>
              <p>SparkCRM Technologies</p>
            </div>
            <div>
              <span className="font-semibold text-gray-500">Country</span>
              <p>India</p>
            </div>
          </div>
        </div>

        {/* Privacy & Terms links — also useful for App Store */}
        <div className="mt-6 flex justify-center gap-6 text-xs text-gray-400">
          <a href="https://apk.sparkcrm.in/privacy" target="_blank" rel="noopener noreferrer" className="hover:text-gray-600 underline">
            Privacy Policy
          </a>
          <a href="https://sparkcrm.in/terms" target="_blank" rel="noopener noreferrer" className="hover:text-gray-600 underline">
            Terms of Service
          </a>
        </div>

        <p className="text-center text-xs text-gray-300 mt-6">
          &copy; {new Date().getFullYear()} SparkCRM. All rights reserved.
        </p>

      </div>
    </div>
  );
};

export default SupportPage;
